import ShopGallery from './imageGalleryJS/shopGallery.js';
import './imageGalleryCSS/style.css';
//import { createRoot } from 'react-dom/client';

/*function App() {
  return (
    <div className="App">
      <ShopGallery />
    </div>
  );
}

export default App;*/

export default function App() {
  return (
    <div className="App">
      <ShopGallery />
    </div>
  );
}
